module.exports = __webpack_public_path__ + "img/org.72cc6e4c.svg";